export default "__VITE_ASSET__397e8a67__"